<h4>
  {{data.title}}
</h4>

<p>
  {{data.body}}
</p>
